import { render, staticRenderFns } from "./LoginOnlyDefault.vue?vue&type=template&id=1b1a6baf&scoped=true&"
import script from "./LoginOnlyDefault.vue?vue&type=script&lang=js&"
export * from "./LoginOnlyDefault.vue?vue&type=script&lang=js&"
import style0 from "./LoginOnlyDefault.vue?vue&type=style&index=0&id=1b1a6baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a6baf",
  null
  
)

export default component.exports